//====================================================
//  Function: Scroll to 
//====================================================
function fn_parts_scroll_to(){
	if( $( '.js-scroll-trigger' ).length ){
		$( '.js-scroll-trigger' ).bind( 'click' , function () {
			var inst = $(this);
			var target = $(this).attr( 'data-scroll' );
			// var height = $( '.navigation' ).height();

			if ($(window).width() < bp_medium){
				var height = $( '.navigation' ).height();
				if (target.length) {
					$( 'html, body' ).stop().animate({
						scrollTop: $( '#' + target + '' ).offset().top - height
					});
					return false;
				}
				
			} else {
	 			if (inst.hasClass( 'scroll-group' )){
				    $.fn.fullpage.moveSectionDown();
	 			}

	 			if (inst.hasClass( 'side-navigation-list-link' )){
				    $.fn.fullpage.moveTo( target );
	 			}
			}


		});
	}
}